import { Database, ref, set } from 'firebase/database';

export const lessonDelete = async (
	database: Database,
	{ id }: { id: string }
): Promise<void> => {
	return set(ref(database, `lessons/${id}`), null);
};
